import { ListItemAction, useGlobalCopyStore, useGoalStore } from '../../../common'
import { Goal } from '../../../core'
import TextField from '@mui/material/TextField'
import React from 'react'

interface RetirementAgeActionProps {
  goal: Goal
}

export const RetirementAgeAction = ({ goal }: RetirementAgeActionProps) => {
  const { goals: copy } = useGlobalCopyStore()
  const { setAlert, setSelectedGoal, updateRetirementGoal } = useGoalStore()

  const [age, setAge] = React.useState(goal.retirement_age || 65)

  const isNew = !goal.guid

  const handleSave = async () => {
    if (!isNaN(age)) {
      const updatedGoal = { ...goal, retirement_age: age }
      goal.retirement_age = age
      if (isNew) {
        setSelectedGoal(updatedGoal)
      } else {
        await updateRetirementGoal(updatedGoal)
        setAlert(copy.alert_goal_updated_retirement_age)
      }
    }
  }

  const handleCancel = () => {
    setTimeout(() => {
      setAge(goal.retirement_age || 65)
    }, 250)
  }

  const isError = !age || isNaN(age) || age < 20 || age >= 100

  return (
    <ListItemAction
      isDisabled={goal.is_complete}
      isSaveDisabled={isError}
      label={copy.details_retirement_age}
      onCancel={handleCancel}
      onSave={handleSave}
      primaryText={copy.details_retirement_age}
      secondaryText={`${goal.retirement_age}`}
      zeroStateText={isNew && !goal.retirement_age ? copy.add_age : undefined}
    >
      <TextField
        error={isError}
        fullWidth={true}
        label={copy.details_retirement_age}
        onChange={(e) => setAge(Number(e.target.value))}
        value={isNaN(age) ? '' : age}
      />
    </ListItemAction>
  )
}
